import React from 'react';
import NewStory from './Styled/StyledNewStory';

export default ({ className, content, title }) => (
    <NewStory className={className}>
        <span className="title">{title}</span>
        <span className="content">{content}</span>
    </NewStory>
);